document.querySelectorAll(".spaces-section").forEach((section) => {
  const tabs = section.querySelectorAll(".spaces-section__li");
  const texts = section.querySelectorAll(".spaces-section__texts");
  const slides = section.querySelectorAll(".spaces-section__right--slide");

  tabs.forEach((tab, index) => {
    tab.addEventListener("click", () => {
      const dataIndex = tab.getAttribute("data-index");

      tabs.forEach((t) => t.classList.remove("isActive"));
      texts.forEach((t) => t.classList.remove("isActive"));
      slides.forEach((s) => s.classList.remove("isActive"));

      tab.classList.add("isActive");
      const activeText = section.querySelector(
        `.spaces-section__texts[data-index="${dataIndex}"]`
      );
      const activeSlide = slides[index];

      if (activeText) activeText.classList.add("isActive");
      if (activeSlide) activeSlide.classList.add("isActive");
    });
  });
});
